import React, { useContext } from 'react';
import { PlanIds } from '../../data/account';
import ModalModule from '../../modal';
import ShipStation from '../../shipstation';
import ShipStationState from '../../shipstation/ShipStationState.enum';
import PlanChangeConfirmationModal from '../../subscriptionPlan/PlanChangeConfirmationModal.component';
import UpgradePlanOrdersAndProductsContent from '../../subscriptionPlan/UpgradePlanOrdersAndProductsContent.component';
import { WrappedButton, WrappedButtonType } from '../../ui/button';
import Utils from '../../utils';

const { BillingPlans, Analytics, Session } = Utils;
const { ModalContext } = ModalModule;

const OrdersUpgradeView = () => {
	const data = {
		upgradePlan: BillingPlans.getPlanByPlanId(PlanIds.EcommerceV383),
	};

	const { Price, Name, PlanId } = data.upgradePlan;
	const { showModal } = useContext(ModalContext);
	const upgradePrompt = 'upgradePromptOrdersTab';

	const onUpgradePlanCallback = () => {
		const settings = Session.getSettings();

		if (settings.ShipStationState === ShipStationState.NotConnected) {
			// Register to SS
			ShipStation.goToRegistration();
		}
	};

	const onChangeNowButtonClick = () => {
		const { customerDetails = {} } = Session.getAccountInfo();
		const customerEmail = customerDetails?.email;

		// EVENT USED BY MARKETING TEAM
		Analytics.trackEvent(
			upgradePrompt,
			{
				pointOfOrigin: 'ordersSettings',
				userAction: 'changeNow',
				email: customerEmail,
			},
			Analytics.agent.segment
		);

		showModal({
			component: PlanChangeConfirmationModal,
			data: {
				newPlanPrice: Price,
				newPlanName: Name,
				newPlanId: PlanId,
				isUpgrade: true,
				upgradePrompt,
				onUpgradePlanCallback,
			},
		});
	};

	return (
		<div className="settings-orders-upgrade-view">
			<div
				className="settings-content-header"
				data-qa="settings-orders-upgrade-view-header"
				{...{ dataqa: 'settings-orders-upgrade-view-header' }}
			>
				<p>Orders</p>
				<hr />
			</div>
			<div className="settings-content">
				<p className="sub-header">
					<strong>Upgrade your plan to manage your orders</strong>
				</p>
				<UpgradePlanOrdersAndProductsContent data={data} />

				<WrappedButton
					label="Change Plan Now"
					buttonType={WrappedButtonType.Primary}
					onClick={onChangeNowButtonClick}
					dataqa="orders-upgrade-change-plan-now"
				/>
			</div>
		</div>
	);
};

export default OrdersUpgradeView;
